function install(Vue) {
    Vue.prototype.$delay = (delay) => {
        return new Promise(reslove => setTimeout(reslove, delay));
    };
}

export default { install };